/* eslint-disable react/no-unknown-property */
import React from 'react';
import styled from 'styled-components';
import truncate from '../../../utils/truncate';

const LabelContainer = styled.tspan`
  font-size: 12px;
  font-family: ${(props) => props.theme.fonts.sfcompact_text};
  color: #2b3d54;
  display: block;

  .country {
    opacity: 0.25;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-weight: 600;
    text-transform: uppercase;
    display: block;
  }
`;

const AxisCountry = ({ x, y, data, index }) => (
  <g verticalAnchor="left">
    <text
      x={x}
      y={y}
      dx={-230}
      textAnchor="start"
      dy={6}
      verticalAnchor="left"
      fill="#666"
    >
      <LabelContainer>
        <tspan className="wine">
          {data[index].name.name && truncate(data[index].name.name, 15)}
        </tspan>
        <tspan
          x={x}
          y={y}
          dx={-90}
          textAnchor="start"
          dy={6}
          verticalAnchor="left"
          className="country"
        >
          {data[index].market}
        </tspan>
      </LabelContainer>
    </text>
  </g>
);

export default AxisCountry;
